export default __webpack_public_path__ + "static/0170-8d5318c510d5a10bed18ed7201d7e3e0.png";